import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {Flow} from '../message/Flow';
import {FlowCriteria} from './FlowCriteria';
import {FlowScenario} from './FlowScenario';

export class FlowWrapper extends BaseWrapper<Flow, FlowCriteria, FlowScenario>  {}

